import React from "react";

import { ApiFrdFrdsListRequest } from "@nens/brostar/openapi-client";

import { SearchBox } from "@/components/searchbox";

import { frdInformation } from "../types";

type Props = {
  searchField: keyof ApiFrdFrdsListRequest;
  setSearchField: (searchField: keyof ApiFrdFrdsListRequest) => void;
  searchString: string;
  setSearchString: (searchString: string) => void;
};

const FrdFilters: React.FC<Props> = ({
  searchField,
  setSearchField,
  searchString,
  setSearchString,
}) => {
  return (
    <SearchBox
      searchField={searchField}
      setSearchField={setSearchField}
      searchString={searchString}
      setSearchString={setSearchString}
      searchOptions={frdInformation}
    />
  );
};

export { FrdFilters };
